import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { getCadastrosTabs } from './cadastros.config';
import styles from './CadastrosLayout.module.css';
export function CadastrosLayout() {
    const { t } = useTranslation();
    const tabs = getCadastrosTabs(t);
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("nav", { className: styles.navigation, "aria-label": t('cadastros.navigation-label'), children: tabs.map(item => (_jsx(NavLink, { to: item.route, end: item.exactMatch ?? true, className: ({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab), children: item.title }, item.route))) }), _jsx("div", { className: styles.content, children: _jsx(Outlet, {}) })] }));
}
export default CadastrosLayout;
